import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
// layouts Format
import DashboardLayout from "../../src/components/dashboard/DashboardLayout"
import NonAuthLayout from "../components/NonAuthLayout"

const Authmiddleware = ({
  component: Component,
  currentUser,
  route,
  isAuthProtected,
  parentRoute,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && currentUser) {
        return (
          <DashboardLayout
            currentRoute={route}
            parentRoute={parentRoute}
            currentUser={currentUser.data}
          >
            <Component title={route.title} {...props} />
          </DashboardLayout>
        )
      }
      return (
        <NonAuthLayout>
          <Component title={route.title} {...props} />
        </NonAuthLayout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  route: PropTypes.any,
  currentUser: PropTypes.object,
  parentRoute: PropTypes.object,
}

export default Authmiddleware
